import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { TIERS, type Tier } from '@ekorank/shared'
import { useAuthStore } from '@/store/auth'
import { LoadingSpinner } from '@/components/LoadingSpinner'

export default function AuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  const setAuth = useAuthStore((s) => s.setAuth)

  useEffect(() => {
    // Use location.search (captured at render) instead of window.location.search
    // to avoid React 18 StrictMode double-firing reading an already-navigated URL.
    const p = new URLSearchParams(location.search)
    const token = p.get('token')
    const id = p.get('id')
    const email = p.get('email')
    const tier = p.get('tier')
    const trial = p.get('trial')
    const isNew = p.get('new') === '1'

    if (!token || !id || !email || !tier || !TIERS.includes(tier as Tier)) {
      navigate('/login?error=oauth_failed', { replace: true })
      return
    }

    setAuth({ id, email, tier: tier as Tier, trialExpiresAt: trial ? Number(trial) : null }, token)
    navigate(isNew ? '/signup?step=1' : '/dashboard', { replace: true })
  }, [])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  )
}
